(() => {
  window.dataLayer = window.dataLayer || [];
  const push = (event, data = {}) => window.dataLayer.push({ event, ...data });
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.id === 'cl-competition' || t.id === 'lh2-comp') push('lott_builder_competition', { competition: t.value });
    if (t.id === 'cl-home' || t.id === 'lh2-home') push('lott_builder_home_team', { team: t.value });
    if (t.id === 'cl-away' || t.id === 'lh2-away') push('lott_builder_away_team', { team: t.value });
  });
  document.addEventListener('submit', (e) => {
    if (e.target.closest('#custom-lott-builder')) {
      const root = e.target.closest('#custom-lott-builder');
      push('lott_builder_add_to_cart', {
        competition: root.querySelector('#cl-competition')?.value || '',
        home_team: root.querySelector('#cl-home')?.value || '',
        away_team: root.querySelector('#cl-away')?.value || ''
      });
    }
    if (e.target.classList.contains('la-email-form')) push('archive_email_signup');
  });
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a'); if (!link) return;
    if (link.href.includes('/pages/request-a-match')) push('request_match_click');
    if (link.href.includes('/pages/request-a-club')) push('request_club_click');
    if (link.href.includes('/products/custom-lott-your-match')) push('build_lott_click');
  });
})();